import { render, staticRenderFns } from "./CheckoutItemList.vue?vue&type=template&id=606756b3&scoped=true"
import script from "./CheckoutItemList.vue?vue&type=script&lang=js"
export * from "./CheckoutItemList.vue?vue&type=script&lang=js"
import style0 from "./CheckoutItemList.vue?vue&type=style&index=0&id=606756b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606756b3",
  null
  
)

export default component.exports